import chinaAdminDivisionData from "../../../../shared/region/china-admin-divisions.json";

export type ChinaCityRegion = {
  code: string;
  name: string;
  districts: ChinaDistrictRegion[];
};

export type ChinaDistrictRegion = {
  code: string;
  name: string;
};

export type ChinaProvinceRegion = {
  code: string;
  name: string;
  cities: ChinaCityRegion[];
};

type ChinaAdminDivisionData = {
  country: string;
  provinces: ChinaProvinceRegion[];
};

export const chinaAreaRegions = (chinaAdminDivisionData as ChinaAdminDivisionData).provinces;

const provinceNameMap = new Map<string, string>();

chinaAreaRegions.forEach((province) => {
  registerProvinceAlias(province.name, province.name);
  if (province.name.endsWith("省") || province.name.endsWith("市")) {
    registerProvinceAlias(province.name.slice(0, -1), province.name);
  }
  province.cities.forEach((city) => {
    registerProvinceAlias(city.name, province.name);
    if (city.name.endsWith("市")) {
      registerProvinceAlias(city.name.slice(0, -1), province.name);
    }
  });
});

/** 注册省份与城市别名到省份映射表。 */
function registerProvinceAlias(alias: string, provinceName: string) {
  const key = normalizeRegionLookupKey(alias);
  if (key && !provinceNameMap.has(key)) {
    provinceNameMap.set(key, provinceName);
  }
}

/** 归一区域名称查找键，去除空白与常见分隔符。 */
function normalizeRegionLookupKey(value: string) {
  return value.replace(/[\s\u3000,，、;；-]/g, "").trim();
}

/** 获取省份选项。 */
export function getProvinceOptions() {
  return chinaAreaRegions.map((province) => province.name);
}

/** 将省份、直辖市或城市值归一为标准省份名称。 */
export function normalizeProvinceName(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const key = normalizeRegionLookupKey(String(value));
  return key ? provinceNameMap.get(key) : undefined;
}

/** 将省份列表归一为标准省份候选，过滤城市脏值并去重。 */
export function normalizeProvinceNames(values: unknown[]): string[] {
  const result: string[] = [];
  values.forEach((value) => {
    const provinceName = normalizeProvinceName(value);
    if (provinceName && !result.includes(provinceName)) {
      result.push(provinceName);
    }
  });
  return result;
}

/** 根据省份获取城市选项。 */
export function getCityOptions(provinceName: string) {
  const cities =
    chinaAreaRegions.find((province) => province.name === provinceName)?.cities ?? [];
  return [...new Set(cities.map((city) => city.name))];
}

/** 根据省份和城市获取区县选项。 */
export function getDistrictOptions(provinceName: string, cityName: string) {
  const cities =
    chinaAreaRegions
      .find((province) => province.name === provinceName)
      ?.cities.filter((city) => city.name === cityName) ?? [];
  return [...new Set(cities.flatMap((city) => city.districts.map((district) => district.name)))];
}
